import { atom, useRecoilValue, useSetRecoilState } from "recoil";

export const departmentListAtom = atom({
  key: "departmentListAtom",
  default: {
    departments: [],
    raw: [],
    loaded: false,
  },
});

export const SetDepartmentList = () => useSetRecoilState(departmentListAtom);
export const GetDepartmentList = () => useRecoilValue(departmentListAtom);
